<template>
  <div class="pulsing-line"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
<style lang="scss" scoped>
.pulsing-line {
  width: 100%;
  height: 0;
  background: var(--blue-86);
  box-shadow: 0 0 0 0 #{var(--blue-86)};
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 1px #{var(--blue-86)};
    opacity: 0.7;
  }

  70% {
    box-shadow: 0 0 0 2px #{var(--blue-93)};
  }

  100% {
    box-shadow: 0 0 0 1px #{var(--blue-93)};
  }
}
</style>
